var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-select-box"},[_c('span',{staticClass:"item",on:{"click":_vm.handleHelp}},[_vm._v("使用帮助")]),_c('span',{staticClass:"item",on:{"click":_vm.handleUser}},[_vm._v("帮助中心")])])}
var staticRenderFns = []

export { render, staticRenderFns }